import React, {useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {Route, Switch, useRouteMatch, useLocation} from "react-router-dom";
import {useSubheader} from "../../../_metronic/layout/_core/MetronicSubheader";
import {useTranslation} from "react-i18next";

//actions:
import {settingsActions} from "../../redux/Settings/settingsRedux";
import {getComponents, getVideos} from "../../redux/Settings/homePageSlice";
import {setHeaderImg} from "../../redux/Layout/layoutSlice";
import {loadParameter} from "../../redux_slices/contextSlice";

//components:
import TracksTableCard from "./TracksTable/index";
import LoginSettings from "./Login";
import HomePageSettings from "./HomePage";
import TopicsTableCard from "./TopicsTable/index";
import Metrics from "./Metrics/index";
import UserBehavior from "./UserBehavior/index";
import MediaItemsTableCard from "./MediaItemsList/index";
import GeneralSettings from "./GeneralSettings/index";
import PlansAndPayment from "./PlansAndPayments/index";
import SettingsMenu from "./Menu/LateralMenuComponent";
import Users from "./Users/index";
import Upload from "./Upload";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const AdminPanel = () => {
    const subheader = useSubheader();
    const location = useLocation();

    const {t} = useTranslation();

    //redux:
    //store:
    const homePic = useSelector(state => loadParameter(state, "homePic"));

    const {
        settings,
        plans = {},
        tracksError = {},
        topicsError = {},
        plansError = {},
        isLoadingSettingTracks = true,
        isLoadingSettingTopics = true,
        isLoadingPlans = true,
    } = useSelector(state => state.settings);

    //actions:
    const dispatch = useDispatch();
    const getSettingTracks = () => dispatch(settingsActions.getSettingTracks());
    const getMetricsTracks = () => dispatch(settingsActions.getMetricsTracks());
    const getPlans = () => dispatch(settingsActions.getPlans());

    const getPageInfo = () => {
        getSettingTracks();
        getMetricsTracks();
        getPlans();
        dispatch(getComponents());
        dispatch(getVideos());
    };

    useEffect(() => {
        getPageInfo();
        dispatch(setHeaderImg(homePic));

        return () => subheader.setTitle("");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        subheader.setTitle(t("ADMINPANEL.PAGE_TITLE"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    useEffect(() => {
        if (homePic) dispatch(setHeaderImg(homePic));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [homePic]);

    //METRICS:

    let match = useRouteMatch();

    return settings ? (
        <div className="adminPannel container">
            <div className="row min-w-100">
                <SettingsMenu />

                <Switch>
                    <Route exact path={`${match.path}/loginpage`}>
                        <LoginSettings />
                    </Route>
                    <Route exact path={`${match.path}/homepage`}>
                        <HomePageSettings />
                    </Route>
                    <Route exact path={`${match.path}/icons`}>
                        <TopicsTableCard isLoading={isLoadingSettingTopics} topicsError={topicsError} />
                    </Route>
                    <Route exact path={`${match.path}/media_items`}>
                        <MediaItemsTableCard />
                    </Route>
                    <Route exact path={`${match.path}/tracks`}>
                        <TracksTableCard isLoading={isLoadingSettingTracks} tracksError={tracksError} />
                    </Route>
                    <Route exact path={`${match.path}/contentaudit`}>
                        <Metrics />
                    </Route>
                    <Route exact path={`${match.path}/userbehaviour`}>
                        <UserBehavior />
                    </Route>
                    <Route exact path={`${match.path}/plans`}>
                        <PlansAndPayment plans={plans} plansError={plansError} isLoadingPlans={isLoadingPlans} />
                    </Route>
                    <Route path={`${match.path}/users`}>
                        <Users />
                    </Route>
                    <Route exact path={`${match.path}/upload`}>
                        <Upload />
                    </Route>
                    <Route exact path={`${match.path}`}>
                        <GeneralSettings />
                    </Route>
                </Switch>
            </div>
        </div>
    ) : (
        <div className="col-12 d-flex justify-content-center align-items-center py-10">
            <div className="alert alert-light text-dark w-fit-content">
                <WarningRoundedIcon color="inherit" className="mr-5" />
                Data not found
            </div>
        </div>
    );
};

export default AdminPanel;
